(function () {

    'use strict';

    angular
        .module('app.layout', [])
        .run(['$rootScope', '$document', function ($rootScope, $document) {
            $rootScope.$on('$viewContentLoaded', function () {
                angular.element($document).foundation();
            });
        }]);

})();


// WEBPACK FOOTER //
// ./app/layout/layout.module.js